import React, { useMemo } from 'react';
import { FormGroup, Input } from 'reactstrap';

const FileUploadArea = React.memo(({
    selectedFile,
    saseCount,
    isProcessing,
    isGenerating,
    onFileSelect,
    onAreaClick
}) => {
    const fileDisplayName = useMemo(() => {
        if (!selectedFile) return null;
        return selectedFile.name.length > 18
            ? selectedFile.name.substring(0, 18) + '...'
            : selectedFile.name;
    }, [selectedFile]);

    const isDisabled = isProcessing || isGenerating;

    return (
        <FormGroup className="mb-0">
            <label className="form-label" style={{ fontSize: '14px' }}>
                Excel Dosyası
            </label>

            <div
                onClick={onAreaClick}
                style={{
                    border: '1px solid #dee2e6',
                    borderRadius: '4px',
                    padding: '8px 12px',
                    textAlign: 'center',
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                    backgroundColor: selectedFile ? '#f8f9fa' : '#ffffff',
                    transition: 'all 0.2s ease',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    opacity: isDisabled ? 0.6 : 1
                }}
                onMouseEnter={(e) => {
                    if (!isDisabled) {
                        e.target.style.borderColor = '#198754';
                        e.target.style.backgroundColor = '#f8f9fa';
                    }
                }}
                onMouseLeave={(e) => {
                    e.target.style.borderColor = '#dee2e6';
                    e.target.style.backgroundColor = selectedFile ? '#f8f9fa' : '#ffffff';
                }}
            >
                {isProcessing ? (
                    <div className="d-flex align-items-center">
                        <span className="spinner-border spinner-border-sm text-primary mr-2"></span> &nbsp;
                        <span className="text-muted" style={{ fontSize: '13px' }}>İşleniyor...</span>
                    </div>
                ) : isGenerating ? (
                    <div className="d-flex align-items-center">
                        <span className="spinner-border spinner-border-sm text-success mr-2"></span> &nbsp;
                        <span className="text-muted" style={{ fontSize: '13px' }}>Rapor oluşturuluyor...</span>
                    </div>
                ) : selectedFile ? (
                    <div className="d-flex align-items-center">
                        <i className="fa fa-file-excel-o text-success mr-2" style={{ fontSize: '14px' }}></i>
                        <div>
                            <span className="text-success" style={{ fontSize: '13px' }}>
                                {fileDisplayName}
                            </span>
                            <small className="text-success ms-2">({saseCount})</small>
                        </div>
                    </div>
                ) : (
                    <div className="d-flex align-items-center">
                        <i className="fa fa-upload text-muted mr-2" style={{ fontSize: '13px' }}></i>
                        <span className="text-muted" style={{ fontSize: '13px' }}>
                            Excel dosyası seçin
                        </span>
                    </div>
                )}
            </div>

            <Input
                id="fileInput"
                type="file"
                accept=".xlsx,.xls"
                onChange={onFileSelect}
                disabled={isDisabled}
                style={{ display: 'none' }}
            />
        </FormGroup>
    );
});

export default FileUploadArea; 